import { render, staticRenderFns } from "./Temporary.vue?vue&type=template&id=73ccde82&scoped=true&"
import script from "./Temporary.vue?vue&type=script&lang=js&"
export * from "./Temporary.vue?vue&type=script&lang=js&"
import style0 from "./Temporary.vue?vue&type=style&index=0&id=73ccde82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ccde82",
  null
  
)

export default component.exports